import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgSlovakia = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M407.899.281H104.101C45.932 4.335 0 52.8 0 112v58.76h512V112C512 52.8 466.068 4.335 407.899.281z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M0 400c0 59.199 45.931 107.665 104.1 111.719h303.8C466.069 507.665 512 459.199 512 400v-58.76H0V400z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M0 170.76h512v170.48H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M163.883 375.426c-3.66-2.102-89.698-52.145-89.698-129.064V141.227h185.533v105.135c0 76.919-86.038 126.962-89.698 129.064l-3.068 1.751-3.069-1.751z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "m215.543 227.809-29.156 3.84h-9.718V214.25h5.83l23.325 3.841-3.159-13.56 3.159-13.557-23.325 3.839h-5.83v-5.877l3.84-29.155-13.558 3.948-13.559-3.948 3.84 29.155v5.877H151.4l-23.323-3.839 3.158 13.557-3.158 13.56 23.323-3.841h5.832v17.399h-9.718l-29.155-3.84 3.948 13.559-3.948 13.558 29.155-3.84h9.718v44.752h19.437v-44.752h9.718l29.156 3.84-3.948-13.558z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M166.951 277.285c-12.775 0-23.733 7.75-28.448 18.802-.83-.068-1.627-.249-2.475-.249-16.465 0-29.797 12.905-30.742 29.131 25.046 30.832 56.415 49.204 58.596 50.457l3.068 1.751 3.068-1.751c2.18-1.253 33.55-19.625 58.596-50.457-.944-16.227-14.277-29.131-30.742-29.131-.848 0-1.644.181-2.475.249-4.713-11.052-15.671-18.802-28.446-18.802z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M253.533 147.412v98.951c0 74.213-86.582 123.688-86.582 123.688s-86.582-49.475-86.582-123.688v-98.951h173.164m12.369-12.369H68v111.32c0 80.465 89.025 132.262 92.814 134.428l6.137 3.506 6.137-3.506c3.789-2.167 92.814-53.963 92.814-134.428v-111.32z"
            })
        ]
    });
export { SvgSlovakia };
